import React, {useEffect, useState} from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Spinner} from 'wix-ui-tpa/cssVars'
import classNames from 'classnames'
import {usePageActions, usePageStateSelector} from '../../../../../hooks/state'
import cl from '../../../../classnames.scss'
import {isMobile} from '../../../../../../../../commons/selectors/environment'
import {classes} from './download-papyrus-tickets.st.css'
import {DownloadPapyrusTicketsProps} from './interfaces'

const DOWNLOAD_RETRY_LIMIT = 20

export const DownloadPapyrusTickets = ({t, className}: DownloadPapyrusTicketsProps) => {
  const ticketsDownloadUrl = usePageStateSelector(state => state.placedOrder.downloadTicketsUrl)
  const loadingTicketsUrl = usePageStateSelector(state => state.placedOrder.loadingTicketsUrl)
  const {openTicketsDownloadModal, getOrderTicketsDownloadUrl} = usePageActions()
  const mobile = usePageStateSelector(isMobile)
  const [initLoading, setInitLoading] = useState<boolean>(true)

  useEffect(() => {
    const init = async () => {
      await getOrderTicketsDownloadUrl(DOWNLOAD_RETRY_LIMIT)
      setInitLoading(false)
    }
    init()
  }, [])

  const handleClick = async () => {
    if (ticketsDownloadUrl) {
      if (mobile) {
        openTicketsDownloadModal()
      } else {
        window.open(ticketsDownloadUrl)
      }
    } else {
      getOrderTicketsDownloadUrl(DOWNLOAD_RETRY_LIMIT)
    }
  }

  return loadingTicketsUrl || initLoading ? (
    <div className={classes.loaderContainer} data-hook={DH.PREPARING_TICKETS}>
      <Spinner diameter={20} className={classes.spinner} />
      <div className={classNames(cl.formLabelsFont, cl.formLabelsColor)}>{t('ticketsThankYou.preparingTickets')}</div>
    </div>
  ) : (
    <button className={className} data-hook={DH.DOWNLOAD_TICKETS} onClick={handleClick}>
      {t('ticketsThankYou.downloadTickets')}
    </button>
  )
}
